// src/components/Global/PriceConfirmation.js
import React, { useState, useEffect, useRef } from 'react';
import { Alert, Form } from 'react-bootstrap';
import AcknowledgementModal from './AcknowledmentModal';

const PriceConfirmation = ({
  originalPrice,
  manualPrice,
  setManualPrice,
  onConfirm,
  inputRef,
  disabled = false,
  inputId = 'price',
  className = '',
  'data-testid': testId,
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [priceLimitExceeded, setPriceLimitExceeded] = useState(false);
  const [internalValue, setInternalValue] = useState(manualPrice || '');
  const hasBlurred = useRef(false);

  useEffect(() => {
    setInternalValue(manualPrice ?? '');
  }, [manualPrice]);

  const handleChange = (e) => {
    const val = e.target.value;
    setInternalValue(val);  // mantener como string para evitar sobrescrituras prematuras
  };
  
  const handleBlur = () => {
    hasBlurred.current = true;
    setTimeout(() => {
      const active = document.activeElement;
      if (inputRef?.current && inputRef.current.contains(active)) return;
  
      const numericValue = parseFloat(internalValue);
      if (isNaN(numericValue)) return;
  
      /*  Temporary disable the 5 and 10% checks */
      
      // const diff = Math.abs(numericValue - originalPrice);
      // const threshold5 = originalPrice * 0.05;
      // const threshold10 = originalPrice * 0.10;
  
      // if (diff > threshold10) {
      //   setPriceLimitExceeded(true);
      //   setManualPrice(originalPrice);
      //   setInternalValue(originalPrice.toString());
      //   onConfirm(originalPrice);
      //   return;
      // }
  
      // if (diff > threshold5) {
      //   setShowWarningModal(true);
      //   return;
      // }
  
      setManualPrice(numericValue);
      onConfirm(numericValue);
    }, 150);
  };

  const confirmManualPrice = () => {
    setShowWarningModal(false);
    setManualPrice(internalValue);
    onConfirm(internalValue);
  };

  const cancelManualPrice = () => {
    setShowWarningModal(false);
    setManualPrice(originalPrice);
    setInternalValue(originalPrice);
    onConfirm(originalPrice);
    setInternalValue(originalPrice.toString());
  };

  return (
    <>
      <Form.Control
        id={inputId}
        type="number"
        value={internalValue}
        ref={inputRef}
        onChange={handleChange}
        onBlur={handleBlur}
        className={className}
        disabled={disabled}
        data-testid={testId}
    />


      {priceLimitExceeded && (
        <Alert variant="danger" onClose={() => setPriceLimitExceeded(false)} dismissible>
          El precio introducido se desvía más de un 10% del recomendado y no está permitido.
        </Alert>
      )}

      <AcknowledgementModal
        show={showWarningModal}
        onConfirm={confirmManualPrice}
        onCancel={cancelManualPrice}
        requiredWord="ENTENDIDO"
        message="Has modificado el precio manualmente más de un 5% respecto al recomendado. Escribe ENTENDIDO para confirmar."
      />
    </>
  );
};

export default PriceConfirmation;
